/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import {
  RichText,
  Text,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import DotComponent from '../../ui/DotComponent';
import Spacer from '../../ui/Spacer';
import {
  processAnalyticsPageData,
  setDataLayerObj,
} from '../../../utils/analytics';
import { Container, Row, Column } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import * as styles from './index.styles';

const emptyValue = {
  value: '',
};

const defaultData = {
  BodyText: emptyValue,
  Subtitle: emptyValue,
  Title: emptyValue,
};
export class ErrorPage extends SafePureComponent {
  fields = defaultsDeep(this.props.fields, defaultData);

  componentDidMount() {
    const data = get(this.props, 'sitecoreContext', {});

    const { route = null } = data;
    const processedData = processAnalyticsPageData(route);

    if (processedData) {
      setDataLayerObj(processedData);
    }
  }

  safeRender() {
    const { BodyText, Subtitle, Title } = this.fields;

    return (
      <Spacer marginCss={styles.mainContainer}>
        <Container css={styles.container}>
          <Row>
            <Column cols={{ sm: 6, md: 6, lg: 6 }} offsets={{ md: 1, lg: 3 }}>
              <h2 css={styles.title}>
                <Text field={Title} />
                <DotComponent />
              </h2>
              <p css={styles.subTitle}>
                <Text field={Subtitle} />
              </p>
              <RichText field={BodyText} css={styles.body} />
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

const objectValueType = {
  value: PropTypes.string,
};

ErrorPage.displayName = 'ErrorPage';

ErrorPage.defaultProps = {
  ...defaultData,
};

ErrorPage.propTypes = {
  BodyText: PropTypes.shape(objectValueType),
  Subtitle: PropTypes.shape(objectValueType),
  Title: PropTypes.shape(objectValueType),
};

export default withSitecoreContext()(ErrorPage);
